import React, { PropsWithChildren } from 'react';

const AssetPreview = ({ children }: PropsWithChildren) => {
  return <div className="AssetPreview">{children}</div>;
};

export default AssetPreview;
